import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import { type Language, SUPPORTED_LANGUAGES } from '@inflearn/i18n-tools';
import type { GetServerSidePropsContext } from 'next/types';
import PolicyLayout from '../../../components/layout/PolicyLayout';
import { PolicyContent } from '../../../components/pages/policy/PolicyContent';
import { HAS_GUIDE_LANG } from '../../../utils/i18n/hasGuideLang';

export const getServerSideProps = async (context: GetServerSidePropsContext) => {
  const locale = context.locale as Language;
  const isWebview = context.query.type === 'app';

  if (HAS_GUIDE_LANG.includes(locale)) {
    return {
      props: {
        isWebview: isWebview,
        ...(await serverSideTranslations(locale, ['common'])),
      },
    };
  }

  return {
    props: {
      isWebview: isWebview,
      ...(await serverSideTranslations(SUPPORTED_LANGUAGES.en, ['common'])),
    },
  };
};

export default function PolicyPrivacyPage({
  isWebview,
}: {
  isWebview: boolean;
}) {
  const { t } = useTranslation();

  return (
    <PolicyLayout
      meta={{
        title: '메타.개인정보처리방침.제목',
        description: '메타.개인정보처리방침.설명',
      }}
      isWebview={isWebview}
    >
      <PolicyContent
        title={t('개인정보 처리방침')}
        prevPolicy={{
          href: '/policy/previous-privacy',
          buttonText: t('이전 개인정보 처리방침 보기'),
        }}
        type="PRIVACY"
        period="CURRENT"
        isWebview={isWebview}
      />
    </PolicyLayout>
  );
}
